var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-table",
        {
          ref: "table",
          staticClass: "q-mt-md",
          attrs: {
            data: _vm.users_invited,
            columns: _vm.columns_users_invited,
            "row-key": "id",
            pagination: _vm.server_pagination,
            loading: _vm.loading,
            selection: "multiple",
            "no-data-label": _vm.$t("no_data_avaliable"),
            "no-results-label": _vm.$t("no_results_found"),
            "loading-label": _vm.$t("loading_data"),
            "rows-per-page-label": _vm.$t("items_per_page"),
            "rows-per-page-options": [5, 10, 50, 100],
            "binary-state-sort": "",
            selected: _vm.users_invited_selected
          },
          on: {
            "update:pagination": function($event) {
              _vm.server_pagination = $event
            },
            request: _vm.requestGuests,
            "update:selected": function($event) {
              _vm.users_invited_selected = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function(props) {
                return _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-th",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: {
                            "indeterminate-value": "some",
                            disable: _vm.disableGuests
                          },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._l(props.cols, function(col) {
                      return _c(
                        "q-th",
                        { key: col.name, attrs: { props: props } },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t(col.label)) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              }
            },
            {
              key: "body",
              fn: function(props) {
                return _c(
                  "q-tr",
                  {},
                  [
                    _c(
                      "q-td",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: {
                            color: "primary",
                            disable: _vm.disableGuests
                          },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _c("q-td", { key: "id", attrs: { props: props } }, [
                      _vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")
                    ]),
                    _c("q-td", { key: "name", attrs: { props: props } }, [
                      _vm._v("\n\t\t\t\t" + _vm._s(props.row.name) + "\n\t\t\t")
                    ]),
                    _c("q-td", { key: "email", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "document", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.document) + "\n\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "branches", attrs: { props: props } },
                      [
                        props.row.branches.length > 1
                          ? _c(
                              "q-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  label: _vm.getQuantityBranches(
                                    props.row.branches
                                  ),
                                  "no-ripple": ""
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  props.row.branches.length > 1
                                    ? _c(
                                        "p",
                                        { staticClass: "tooltip q-mb-sm" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.$t("branches")) +
                                              ":\n\t\t\t\t\t\t\t"
                                          ),
                                          _vm._l(props.row.branches, function(
                                            branch,
                                            index
                                          ) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(branch) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                              props.row.branches.length - 1 >
                                              index
                                                ? _c("span", [_vm._v(", ")])
                                                : _vm._e()
                                            ])
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        props.row.branches.length < 2
                          ? _c("span", [
                              _vm._v(_vm._s(String(props.row.branches)))
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "areas", attrs: { props: props } },
                      [
                        props.row.areas.length > 1
                          ? _c(
                              "q-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  label: props.row.areas
                                    ? props.row.areas.length
                                    : 0,
                                  "no-ripple": ""
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  props.row.areas.length > 1
                                    ? _c(
                                        "p",
                                        { staticClass: "tooltip q-mb-sm" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.$t("areas")) +
                                              ":\n\t\t\t\t\t\t\t"
                                          ),
                                          _vm._l(props.row.areas, function(
                                            area,
                                            index
                                          ) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(area) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              ),
                                              props.row.areas.length - 1 > index
                                                ? _c("span", [_vm._v(", ")])
                                                : _vm._e()
                                            ])
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        props.row.areas.length < 2
                          ? _c("span", [
                              _vm._v(_vm._s(String(props.row.areas)))
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("q-td", { key: "profile", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.translateProfiles(props.row.profile)) +
                          "\n\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "is_present", attrs: { props: props } },
                      [
                        _c("q-checkbox", {
                          attrs: { "aria-readonly": "true", disable: "" },
                          model: {
                            value: props.row.is_present,
                            callback: function($$v) {
                              _vm.$set(props.row, "is_present", $$v)
                            },
                            expression: "props.row.is_present"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "subscribe_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.fDate(props.row.subscribe_date)) +
                            "\n\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "actions",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              round: "",
                              flat: "",
                              icon: "fas fa-trash",
                              color: "negative",
                              disable: _vm.disableGuests
                            },
                            on: {
                              click: function($event) {
                                return _vm.removeGuest(props)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("delete_tooltip")) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }
            }
          ])
        },
        [
          _c(
            "template",
            { slot: "top" },
            [
              _c("div", { staticClass: "col" }),
              _c("q-btn", {
                staticClass: "q-mr-sm",
                attrs: {
                  color: "tertiary",
                  icon: "fas fa-file-download",
                  label: _vm.$t("download_guest_list"),
                  disable: _vm.users_invited.length < 1 || _vm.disableGuests
                },
                on: { click: _vm.downloadGuestList }
              }),
              _vm.users_invited_selected.length > 0
                ? _c("q-btn", {
                    staticClass: "q-mr-sm",
                    attrs: {
                      color: "negative",
                      icon: "fas fa-ban",
                      label: _vm.$t("remove"),
                      disable: _vm.disableGuests
                    },
                    on: { click: _vm.removeGuests }
                  })
                : _vm._e(),
              _c("q-btn", {
                attrs: {
                  color: "secondary",
                  icon: "fas fa-plus",
                  label: _vm.$t("add_guests"),
                  disable: _vm.disableGuests
                },
                on: { click: _vm.showAddGuests }
              })
            ],
            1
          )
        ],
        2
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_live_classes" })
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_guests,
            callback: function($$v) {
              _vm.show_guests = $$v
            },
            expression: "show_guests"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_guests = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("guests")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c(
                    "q-table",
                    {
                      attrs: {
                        data: _vm.guests_list,
                        columns: _vm.guests_columns,
                        pagination: _vm.new_guests_pagination,
                        filter: _vm.filter_guests,
                        loading: _vm.loading,
                        selection: "multiple",
                        selected: _vm.users_invited_selected,
                        "row-key": "id",
                        "no-data-label": _vm.$t("no_data_avaliable"),
                        "no-results-label": _vm.$t("no_results_found"),
                        "loading-label": _vm.$t("loading_data"),
                        "rows-per-page-label": _vm.$t("items_per_page"),
                        "rows-per-page-options": [5, 10, 50, 100],
                        "binary-state-sort": ""
                      },
                      on: {
                        "update:pagination": function($event) {
                          _vm.new_guests_pagination = $event
                        },
                        request: _vm.requestNewGuests,
                        "update:selected": function($event) {
                          _vm.users_invited_selected = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function(props) {
                            return _c(
                              "q-tr",
                              { attrs: { props: props } },
                              [
                                _c(
                                  "q-th",
                                  { attrs: { "auto-width": "" } },
                                  [
                                    _c("q-checkbox", {
                                      attrs: { "indeterminate-value": "some" },
                                      model: {
                                        value: props.selected,
                                        callback: function($$v) {
                                          _vm.$set(props, "selected", $$v)
                                        },
                                        expression: "props.selected"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._l(props.cols, function(col) {
                                  return _c(
                                    "q-th",
                                    { key: col.name, attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t(col.label)) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          }
                        },
                        {
                          key: "body",
                          fn: function(props) {
                            return _c(
                              "q-tr",
                              { attrs: { props: props } },
                              [
                                _c(
                                  "q-td",
                                  { attrs: { "auto-width": "" } },
                                  [
                                    _c("q-checkbox", {
                                      attrs: { color: "primary" },
                                      model: {
                                        value: props.selected,
                                        callback: function($$v) {
                                          _vm.$set(props, "selected", $$v)
                                        },
                                        expression: "props.selected"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-td",
                                  { key: "id", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(props.row.id) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "name", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(props.row.name) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "email", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(props.row.email) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  { key: "profile", attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.translateProfiles(
                                            props.row.profile
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "template",
                        { slot: "top" },
                        [
                          _c("q-search", {
                            staticClass: "q-mr-lg",
                            attrs: {
                              icon: "fas fa-search",
                              placeholder: _vm.$t("search"),
                              "float-label": _vm.$t("search"),
                              debounce: 600
                            },
                            model: {
                              value: _vm.filter_guests,
                              callback: function($$v) {
                                _vm.filter_guests = $$v
                              },
                              expression: "filter_guests"
                            }
                          }),
                          _c("q-select", {
                            staticClass: "q-mr-lg",
                            attrs: {
                              chips: "",
                              multiple: "",
                              options: _vm.getAllowedAreas,
                              "float-label": _vm.$t("area")
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeAddFilter()
                              }
                            },
                            model: {
                              value: _vm.area,
                              callback: function($$v) {
                                _vm.area = $$v
                              },
                              expression: "area"
                            }
                          }),
                          _c(
                            "q-chips-input",
                            {
                              staticClass: "q-mr-lg",
                              attrs: {
                                "float-label": _vm.$t("branches"),
                                debounce: 600,
                                clearable: ""
                              },
                              on: {
                                remove: _vm.removeBranch,
                                clear: _vm.clearAutoComplete
                              },
                              model: {
                                value: _vm.branches,
                                callback: function($$v) {
                                  _vm.branches = $$v
                                },
                                expression: "branches"
                              }
                            },
                            [
                              _c("q-autocomplete", {
                                attrs: {
                                  "min-characters": 3,
                                  "max-results": 50
                                },
                                on: {
                                  search: _vm.fetchBranches,
                                  selected: _vm.selectedBranch
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-chips-input",
                            {
                              staticClass: "q-mr-lg",
                              attrs: {
                                "float-label": _vm.$t("company"),
                                debounce: 600,
                                clearable: ""
                              },
                              on: {
                                remove: _vm.removeCompany,
                                clear: _vm.clearAutoComplete
                              },
                              model: {
                                value: _vm.companies,
                                callback: function($$v) {
                                  _vm.companies = $$v
                                },
                                expression: "companies"
                              }
                            },
                            [
                              _c("q-autocomplete", {
                                attrs: {
                                  "min-characters": 3,
                                  "max-results": 50
                                },
                                on: {
                                  search: _vm.fetchCompanies,
                                  selected: _vm.selectedCompany
                                }
                              })
                            ],
                            1
                          ),
                          _c("q-select", {
                            staticClass: "q-mr-lg",
                            attrs: {
                              chips: "",
                              multiple: "",
                              options: _vm.getAllowedUserGroups,
                              "float-label": _vm.$t("user_groups")
                            },
                            on: {
                              input: function($event) {
                                return _vm.changeAddFilter()
                              }
                            },
                            model: {
                              value: _vm.user_group,
                              callback: function($$v) {
                                _vm.user_group = $$v
                              },
                              expression: "user_group"
                            }
                          }),
                          _c("div", { staticClass: "col" })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm  justify-end q-mt-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3 " },
                        [
                          _vm.getAllowedProfiles.length
                            ? _c("q-btn", {
                                staticClass: "full-width",
                                attrs: {
                                  color: "secondary",
                                  label: _vm.$t("register_new_users"),
                                  icon: "fas fa-plus"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showCreateUsersGuests()
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "positive",
                              icon: "far fa-save",
                              label: _vm.$t("add_guests"),
                              disable: _vm.users_invited_selected.length < 1
                            },
                            on: {
                              click: function($event) {
                                return _vm.addGuests()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_create_users,
            callback: function($$v) {
              _vm.show_create_users = $$v
            },
            expression: "show_create_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideCreateUsers()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("new_users")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.new_user.email_error,
                              "error-label": _vm.new_user.email_error
                                ? "" + _vm.$t("email_not_unique")
                                : ""
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("email"),
                                error: _vm.$v.new_user.email.$error,
                                disable: !this.register_fields.email_fields
                              },
                              on: {
                                input: _vm.$v.new_user.email.$touch,
                                blur: function($event) {
                                  return _vm.emailUnique()
                                }
                              },
                              model: {
                                value: _vm.new_user.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.new_user, "email", $$v)
                                },
                                expression: "new_user.email"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.new_user.document_error,
                              "error-label": _vm.new_user.document_error
                                ? _vm.$t("document_not_unique")
                                : ""
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("document"),
                                error: _vm.$v.new_user.document.$error
                              },
                              on: {
                                input: _vm.$v.new_user.document.$touch,
                                blur: function($event) {
                                  return _vm.documentUnique()
                                }
                              },
                              model: {
                                value: _vm.new_user.document,
                                callback: function($$v) {
                                  _vm.$set(_vm.new_user, "document", $$v)
                                },
                                expression: "new_user.document"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-2" },
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": _vm.$t("profile"),
                            options: _vm.getAllowedProfiles,
                            error: _vm.$v.new_user.profile.$error
                          },
                          on: { input: _vm.$v.new_user.profile.$touch },
                          model: {
                            value: _vm.new_user.profile,
                            callback: function($$v) {
                              _vm.$set(_vm.new_user, "profile", $$v)
                            },
                            expression: "new_user.profile"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("full_name"),
                            error: _vm.$v.new_user.full_name.$error
                          },
                          on: { input: _vm.$v.new_user.full_name.$touch },
                          model: {
                            value: _vm.new_user.full_name,
                            callback: function($$v) {
                              _vm.$set(_vm.new_user, "full_name", $$v)
                            },
                            expression: "new_user.full_name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1" },
                      [
                        _c("q-btn", {
                          staticClass: "q-mt-md",
                          attrs: {
                            round: "",
                            flat: "",
                            color: "positive",
                            icon: "fas fa-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addNewExternalUser()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._l(_vm.new_users, function(user, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "row gutter-sm" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("email"),
                                disable: ""
                              },
                              model: {
                                value: user.email,
                                callback: function($$v) {
                                  _vm.$set(user, "email", $$v)
                                },
                                expression: "user.email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("document"),
                                disable: ""
                              },
                              model: {
                                value: user.document,
                                callback: function($$v) {
                                  _vm.$set(user, "document", $$v)
                                },
                                expression: "user.document"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-2" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": _vm.$t("profile"),
                                options: _vm.getAllowedProfiles,
                                disable: ""
                              },
                              model: {
                                value: user.profile,
                                callback: function($$v) {
                                  _vm.$set(user, "profile", $$v)
                                },
                                expression: "user.profile"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("full_name"),
                                disable: ""
                              },
                              model: {
                                value: user.full_name,
                                callback: function($$v) {
                                  _vm.$set(user, "full_name", $$v)
                                },
                                expression: "user.full_name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-1" },
                          [
                            _c("q-btn", {
                              staticClass: "q-mt-md",
                              attrs: {
                                color: "negative",
                                round: "",
                                flat: "",
                                icon: "fas fa-trash"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeExternalUser(index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "fas fa-chevron-left"
                            },
                            on: {
                              click: function($event) {
                                return _vm.hideCreateUsers()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save_new_users"),
                              icon: "far fa-save",
                              disable: _vm.new_users.length === 0 ? true : false
                            },
                            on: {
                              click: function($event) {
                                return _vm.addExternalUser()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }